import { Panel } from "@appkit4/react-components";
import {
  getGroupData,
  getGroupName,
  getFormattedSelectedPeriod,
  getReturnStatus,
  getSelectedPeriod,
  isSubmissionOverdue,
} from "../services/GroupContext";
import { processDateJS } from "../utils/dateProcessor";

export const getUltParent = () => {
  const savedData = getGroupData();
  if (!savedData) {
    return;
  }

  const ultimateParent = savedData?.companies?.find(
    (comp) => comp.company_ID === savedData.ult_parent_ID,
  );
  return ultimateParent?.company_name;
};

const getStatusDotMarkup = (color) => {
  const statusColors = {
    green: "#87e964",
    amber: "#ffbf00",
    red: "#ff6666",
  };

  return (
    <div
      style={{
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: statusColors[color],
      }}
    ></div>
  );
};
const getStatusDot = (returnStatus) => {
  const selectedPoA = getSelectedPeriod();
  const isSubmitted = returnStatus?.isSubmitted === true;
  const isRevised = returnStatus?.isRevised === true;
  const hasActiveReportingCompany = Boolean(
    selectedPoA?.reporting_company ?? false,
  );
  const submissionOverdue = isSubmissionOverdue(selectedPoA);

  if (isSubmitted) return getStatusDotMarkup("green");
  if (submissionOverdue && !isRevised) return getStatusDotMarkup("red");
  if (!hasActiveReportingCompany) return getStatusDotMarkup("amber");
  return null;
};

const CompanyPanel = ({
  showPeriod = true,
  showStatus = false,
  returnStatus = undefined,
}) => {
  return (
    <Panel>
      <div className="row">
        <label className="col-sm-2 col-form-label">Group Name</label>
        <div className="col-sm-10">
          <b>{getGroupName()}</b>
        </div>
      </div>
      <div className="row">
        <label className="col-sm-2 col-form-label">Ultimate Parent</label>
        <div className="col-sm-10">
          <b>{getUltParent()}</b>
        </div>
      </div>
      {showPeriod && (
        <div className="row">
          <label className="col-sm-2 col-form-label align-self-center">
            Period of Account
          </label>
          <div className="col-sm-10">
            <b>{getFormattedSelectedPeriod()}</b>
          </div>
        </div>
      )}
      {showPeriod && (
        <div className="row">
          <label className="col-sm-2 col-form-label align-self-center">
            Return Status
          </label>
          <div className="col-sm-10 d-flex gap-2 align-items-center">
            <b>{getReturnStatus()}</b>
            {showStatus && getStatusDot(returnStatus)}
          </div>
        </div>
      )}
    </Panel>
  );
};

export default CompanyPanel;
